interface IArgumentsListItemProps {
  children: React.ReactNode;
  UNSAFE_className?: string;
}

const ArgumentsListItem: React.FC<IArgumentsListItemProps> = ({
  children,
  UNSAFE_className,
}) => {
  return (
    <li
      className={`${UNSAFE_className} tw-lf-body-regular-sm tw-lf-bullet-list-item tw-mb-1 tw-flex tw-items-center tw-leading-[21px] desktop:tw-lf-body-regular-md desktop:tw-mb-3`}
    >
      {children}
    </li>
  );
};

export default ArgumentsListItem;
